import { createFileRoute } from "@tanstack/react-router";
import { DigitalMarketplaceManager } from "@/components/admin/digital-marketplace-manager";

export const Route = createFileRoute("/_authenticated/admin/digital-marketplace")({
  component: () => <DigitalMarketplaceManager />,
});
